import { foreignRecords } from './foreign_records';

export const views = $axios => ({
  // nested resources
  foreignRecords: foreignRecords($axios),
});
